import { createSelector } from '@app/utils/createSelector'

import type { V3SitterStatistics } from '@app/packages/api/v3/types/lib'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { routingDateSelector } from './routing'
import { authIdentitySelector } from './session'

const sitterStatisticsSlice = createReduxSlice<SliceState<V3SitterStatistics>>('sitter_statistics')

/**
 * One window, the server's default of the last 12 months. The page reads its `< >` out of
 * `months[]` rather than refetching — see `useMonthWindow`.
 */
export const sitterStatisticsResultSelector = createSelector(
  [sitterStatisticsSlice.selector, routingDateSelector, authIdentitySelector],
  (sliceState, date, identity) =>
    createLoadable(c =>
      withCheckedSliceState(c, {
        sliceState,
        slice: sitterStatisticsSlice,
        // Whose numbers these are, so a supervisor stepping into another account refetches.
        hash: identity ?? 'anonymous',
        date: { date, expiresInMinutes: 15 },
        load: async dispatch => {
          const { getSitterStatistics } = await import('@app/packages/api/v3/actions/sitter_statistics')
          const resp = await dispatch(callApi(getSitterStatistics()))
          return resp.data
        },
      })
    )
)
